export default {
    AntDesign: {
        locale: "en_US",
    },
    DatePicker: {
        lang: {},
    },
};
//# sourceMappingURL=ias.en.js.map